import React from 'react';
import { Box, Typography } from '@mui/material';
import { RichTextEditor } from './Editor/plugins/RichTextEditor';

interface InputCommentProps {
  onChange?: (value: string) => void;
  value: string;
  readonly?: boolean;
  autoFocus?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLDivElement>) => void;
  shadow?: boolean;
}

const InputComment: React.FC<InputCommentProps> = ({
  onChange,
  value,
  readonly,
  autoFocus,
  onKeyDown,
  onBlur,
  shadow = false,
}) => {
  if (readonly) {
    return (
      <RichTextEditor
        value={value}
        readOnly
        compact
        minHeight="unset"
        onBlur={onBlur}
        sx={{
          border: 'none',
          bgcolor: 'transparent',
          '& [class*="_toolbar_"]': { display: 'none' },
          '& [contenteditable]': { p: 0, minHeight: 'unset' },
          '&:focus-within': { borderColor: 'transparent', boxShadow: 'none' },
        }}
      />
    );
  }

  return (
    <Box sx={shadow ? { boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px' } : {}}>
      <RichTextEditor
        value={value}
        onChange={onChange}
        readOnly={false}
        compact
        minHeight={80}
        autoFocus={autoFocus}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        placeholder="Scrivi un commento..."
        sx={{
          bgcolor: 'white',
          '& [class*="_toolbar_"]': { bgcolor: 'white' },
          '& [contenteditable]': { py: 0.5 },
        }}
      />
    </Box>
  );
};

export default InputComment;